import { deleteForm } from './delete-form';
import { deleteFormOld } from './delete-form-old';
import { hasSeenOnboarding } from './has-seen-onboarding';
import { loadIndex } from './load-index';
import { markAsSeenOnboarding } from './mark-as-seen-onboarding';
import { reopenForm } from './reopen-form';
import { reportError } from './report-error';
import { saveAnswers } from './save-answers';
import { setFormViewMode } from './set-form-view-mode';
import { setIsIndexLoading } from './set-is-index-loading';
import { setSelectedFormId } from './set-selected-form-id';
import { setSelectedFormStore } from './set-selected-form-store';
import { setSelectedFormStoreState } from './set-selected-form-store-state';
import { submitForm } from './submit-form';
import { updateFormStatus } from './update-form-status';
import { updateFormVisibility } from './update-visibility';
export const actions = {
  deleteFormOld,
  deleteForm,
  hasSeenOnboarding,
  loadIndex,
  markAsSeenOnboarding,
  setIsIndexLoading,
  setSelectedFormId,
  updateFormVisibility,
  updateFormStatus,
  reopenForm,
  submitForm,
  saveAnswers,
  setSelectedFormStore,
  setFormViewMode,
  reportError,
  setSelectedFormStoreState
};